import React, { ReactNode, useState } from 'react';
import styled from 'styled-components';
import { Message, Select } from '@kvdbil/components';
import { useTranslation } from '~/Locale';
import { AddressAutocompleteState } from '../hooks/useAddressAutocomplete';
import { GeneralRulesMessagesWrapper } from './Messages';

const SelectFieldContent = styled.div`
  margin-left: 1rem;
`;

interface Props {
  state: AddressAutocompleteState;
  label?: string;
  placeholder?: string;
  emptyOptionsMessage?: ReactNode;
  noOptionsFoundMessage?: ReactNode;
}

export const AddressAutocompleteSelect = ({
  state,
  label,
  placeholder,
  emptyOptionsMessage,
  noOptionsFoundMessage
}: Props) => {
  const { t } = useTranslation();
  const {
    value,
    options,
    inputValue,
    handleAddressSelect,
    handleInputChange,
    handleOnBlur,
    handleMenuOpen,
    handleMenuClose,
    isAddressValid
  } = state;

  const resolvedLabel = label ?? t('Address');
  const resolvedPlaceholder = placeholder ?? t('Address');

  const [hasInteracted, setHasInteracted] = useState(false);

  const onBlur = () => {
    setHasInteracted(true);
    handleOnBlur();
  };

  const onChange: typeof handleAddressSelect = option => {
    setHasInteracted(true);
    handleAddressSelect(option);
  };

  return (
    <SelectFieldContent>
      <Select
        instanceId="address-autocomplete"
        color="info"
        colorShade="dark"
        name="address"
        label={resolvedLabel}
        value={value ? { value, label: value } : null}
        placeholder={resolvedPlaceholder}
        noOptionsMessage={() => {
          if (value) {
            return noOptionsFoundMessage ?? t('No addresses found');
          }
          return emptyOptionsMessage ?? t('Start to type to show adresses..');
        }}
        inputValue={inputValue}
        onChange={onChange}
        onInputChange={handleInputChange}
        options={options}
        filterOption={null}
        onMenuOpen={handleMenuOpen}
        onMenuClose={handleMenuClose}
        onBlur={onBlur}
      />
      {hasInteracted && value && !isAddressValid && (
        <GeneralRulesMessagesWrapper spacing={1}>
          <Message fullWidth type="error">
            {t('Address invalid')}
          </Message>
        </GeneralRulesMessagesWrapper>
      )}
    </SelectFieldContent>
  );
};

export default AddressAutocompleteSelect;
